export const schoolStaffsReducer = (state = {loading: true, result: null, schoolStaffs: []} , action) => {
    switch (action.type) {
        case 'SCHOOL_STAFF_GET_ALL_SUCCESS':
            return {
                ...state,
                loading: false,
                schoolStaffs: action.payload
            }
        case 'SCHOOL_STAFF_EDIT_SUCCESS':
            return {
                ...state,
                loading: false,
                result: action.payload.message,
                schoolStaffs: action.payload.schoolStaff ? state.schoolStaffs.map(schoolStaff =>
                    schoolStaff.staffId === action.payload.schoolStaff.staffId ? action.payload.schoolStaff : schoolStaff
                ) : state.schoolStaffs
            }
        case 'SCHOOL_STAFF_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                result: action.payload.message,
                schoolStaffs: action.payload.schoolStaff ? [...state.schoolStaffs, action.payload.schoolStaff] : state.schoolStaffs
            }
        case 'SCHOOL_STAFF_REMOVE_SUCCESS':
            return {
                ...state,
                loading: false,
                result: action.payload.message,
                schoolStaffs: state.schoolStaffs.filter(schoolStaff => schoolStaff.staffId !== action.payload.schoolStaff)
            }
        case 'SCHOOL_STAFF_RESET_RESULT':
            return {...state,
                result: null
            }
        case 'SCHOOL_STAFF_LOADING':
            return {
                ...state,
                loading: true
            }
        case 'SCHOOL_STAFF_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        default:
            return state
    }
}

